var BookmarkButton   = require("app/Bookmarks/BookmarkButton"),
    HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    ShareButton      = require("app/Sharing/ShareButton"),
    ThumbnailImage   = require("app/ui/thumbnails/ThumbnailImage"),
    buttons          = require("app/theme/buttons"),
    formatDuration   = require("app/utils/formatDuration"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap");

require("./PlaylistItem.less");

module.exports = kind(/** @lends app.ArtistPage.PlaylistItem.prototype */ {

    /**
     * @private
     */
    name: "app.ArtistPage.PlaylistItem",

    /**
     * @private
     */
    classes: "app-artist-page-playlist-item",

    /**
     * @private
     */
    tag: "tr",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        classes: "app-artist-page-playlist-item__left-spacer",
        tag:     "td"
    }, {
        tag:        "td",
        components: [{
            name:    "number",
            classes: "app-artist-page-playlist-item__number",
            mixins:  [HyperLinkSupport],
            ontap:   "onPlayLinkTap"
        }]
    }, {
        tag:        "td",
        components: [{
            name:       "thumbnailWrapper",
            classes:    "app-artist-page-playlist-item__thumbnail-wrapper",
            mixins:     [HyperLinkSupport],
            ontap:      "onPlayLinkTap",
            components: [{
                name:       "thumbnail",
                kind:       ThumbnailImage,
                classes:    "app-artist-page-playlist-item__thumbnail",
                formFactor: "square"
            }]
        }]
    }, {
        classes:    "app-artist-page-playlist-item__meta-text",
        tag:        "td",
        components: [{
            name:       "titles",
            classes:    "app-artist-page-playlist-item__titles",
            mixins:     [HyperLinkSupport],
            ontap:      "onPlayLinkTap",
            components: [{
                name:    "title",
                tag:     "h3",
                classes: "app-artist-page-playlist-item__title"
            }, {
                name:    "secondaryTitle",
                tag:     "h4",
                classes: "app-artist-page-playlist-item__secondary-title color-alt"
            }]
        }]
    }, {
        tag:        "td",
        components: [{
            name:    "duration",
            classes: "app-artist-page-playlist-item__duration color-alt",
            mixins:  [HyperLinkSupport],
            ontap:   "onPlayLinkTap"
        }]
    }, {
        tag:        "td",
        components: [{
            name:       "actionButtons",
            classes:    "app-artist-page-playlist-item__action-buttons",
            components: [{
                name:        "infoButton",
                kind:        IconButton,
                mixins:      [HyperLinkSupport],
                classes:     "app-artist-page-playlist-item__info-button",
                theme:       buttons["app.ArtistPage.PlaylistItem.infoButton"],
                showCaption: false,
                icon:        icons["app.ArtistPage.PlaylistItem.infoButton"],
                ontap:       "onHyperlinkTap"
            }, {
                name:           "bookmarkButton",
                kind:           BookmarkButton,
                classes:        "app-artist-page-playlist-item__bookmark-button",
                theme:          buttons["app.ArtistPage.PlaylistItem.bookmarkButton"],
                showCaption:    false,
                showToast:      true,
                bookmarkIcon:   icons["app.Bookmarks.BookmarkButtonAlt.bookmark"],
                unbookmarkIcon: icons["app.Bookmarks.BookmarkButtonAlt.unbookmark"]
            }, {
                name:        "shareButton",
                kind:        ShareButton,
                classes:     "app-artist-page-page-playlist-item__share-button",
                theme:       buttons["app.ArtistPage.PlaylistItem.shareButton"],
                showCaption: false
            }]
        }]
    }, {
        classes: "app-artist-page-playlist-item__right-spacer",
        tag:     "td"
    }],

    /**
     * @private
     */
    observers: {
        update:       ["data"],
        updateActive: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update       = frameThrottle(this.bindSafely(this.update));
            this.updateActive = frameThrottle(this.bindSafely(this.updateActive));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.state.mediaPlayerMediaId", this.updateActive);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $i18nService      = this.app.$.i18nService,
            data              = this.data || {},
            infoLink          = get(data, "links.details", null),
            $number           = this.$.number,
            $thumbnailWrapper = this.$.thumbnailWrapper,
            $titles           = this.$.titles,
            $title            = this.$.title,
            $secondaryTitle   = this.$.secondaryTitle,
            $duration         = this.$.duration,
            $infoButton       = this.$.infoButton;

        $number.setAttribute("href", get(data, "links.player", null));
        $number.set("tooltip", $i18nService.getString("app.ArtistPage.Playlist.PlayButton.tooltip"));
        $number.set("content", get(data, "playlist_nr", null) || "");

        $thumbnailWrapper.set("tooltip", $i18nService.getString("app.ArtistPage.Playlist.PlayButton.tooltip"));
        $thumbnailWrapper.setAttribute("href", get(data, "links.player", null));
        this.$.thumbnail.set("data", data || null);

        $titles.setAttribute("href", get(data, "links.player", null));
        $titles.set("tooltip", $i18nService.getString("app.ArtistPage.Playlist.PlayButton.tooltip"));

        $title.set("content", get(data, "meta.title", null) || "");
        $title.set("showing", Boolean(get(data, "meta.title", null)));

        $secondaryTitle.set("content", get(data, "meta.secondary_title", null) || "");
        $secondaryTitle.set("showing", Boolean(get(data, "meta.secondary_title", null)));

        $duration.setAttribute("href", get(data, "links.player", null));
        $duration.set("tooltip", $i18nService.getString("app.ArtistPage.Playlist.PlayButton.tooltip"));
        $duration.set("content", formatDuration(get(data, "primary_asset_length", 0)));

        $infoButton.set("tooltip", $i18nService.getString("app.ArtistPage.Playlist.InfoButton.tooltip"));
        $infoButton.set("href", infoLink);
        infoLink ? $infoButton.show() : $infoButton.hide();
        this.$.bookmarkButton.set("mediaItem", data);
        this.$.shareButton.set("mediaItem", data);
    },

    /**
     * @private
     */
    updateActive: function() {
        var $appState          = this.app.$.state,
            mediaPlayerMediaId = $appState.get("mediaPlayerMediaId"),
            mediaItemId        = get(this.data, "id", null);

        if (mediaPlayerMediaId && mediaItemId && mediaPlayerMediaId === mediaItemId) {
            !this.hasClass("active") && this.addClass("active");
        }
        else {
            while (this.hasClass("active")) {
                this.removeClass("active");
            }
        }
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @param   {enyo.Control}  sender  The sender
     * @return  {boolean}       Stop propagation
     * @private
     */
    onPlayLinkTap: function() {
        var mediaItem = this.data || {};

        if (mediaItem) {
            this.app.$.mediaPlayerManager.userNavToMediaItem(mediaItem);
        }

        return true;
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
